interface TagProps {
  text: string;
  color?: "primary" | "success" | "warning" | "danger" | "neutral";
  variant?: "soft" | "solid";
  onRemove?: () => void;
  size?: "xs" | "sm" | "md";
  padding?: "tight" | "normal" | "wide";
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function Tag({
  text,
  color = "primary",
  variant = "soft",
  onRemove,
  size = "xs",
  padding = "tight",
  onClick,
}: TagProps) {
  const colorStyles = {
    soft: {
      primary: "text-primary-600 bg-primary-50",
      success: "text-success-700 bg-success-50",
      warning: "text-warning-700 bg-warning-50",
      danger: "text-error-600 bg-error-50",
      neutral: "text-neutral-600 bg-neutral-100",
    },
    solid: {
      primary: "text-white bg-primary-300",
      success: "text-white bg-success-700",
      warning: "text-white bg-warning-600",
      danger: "text-white bg-error-600",
      neutral: "text-white bg-neutral-600",
    },
  };

  const sizes = {
    xs: "text-[11px]",
    sm: "text-[12px]",
    md: "text-base",
  };

  const paddings = {
    tight: "px-2 py-0.7",
    normal: "px-2 py-1",
    wide: "px-3 py-1.5",
  };

  return (
    <button
      onClick={onClick}
      className={`${colorStyles[variant][color]} ${sizes[size]} ${paddings[padding]}
      rounded font-medium ml-1 flex items-center gap-1 w-fit capitalize`}
    >
      {text}
      {onRemove && (
        <button onClick={onRemove} className="text-error-200 font-bold">
          ×
        </button>
      )}
    </button>
  );
}
